export default "__VITE_ASSET__C4tH87z5__"